import React from "react";
import BrandIcon from "../../components/BrandIcon";
import { routes } from "utilities/routing/generatedRoutes";
import { AdvancingSessionCard } from "advancing/components/AdvancingSessionCard";

interface Props {
  item: server.dto.AdvancingSessionForListForParticipant
}

const AdvancingProvideRowCard = (props: Props) => {
  const { item } = props;
  const { brand } = item.advancingSession;

  return <AdvancingSessionCard
    session={item.advancingSession}
    side="participant"
    href={routes.advancing_InvitationLanding(item.secret).absolute}
    logo={<div className="advancing-session-card-logo flex align-center justify-center flex-noshrink">
      <BrandIcon name={brand.name} iconUrl={brand.iconUrl} size={64} />
    </div>}
  />;
};

export default AdvancingProvideRowCard;
